<template>
    <span>
        <slot v-bind:toggleCollapsible="toggleCollapsible" name="collapsibleTrigger"></slot>
        <transition name="fade" mode="out-in">
            <slot v-if="showContent" name="collapsibleContent"></slot>
        </transition>
    </span>
</template>

<script>
    export default {
        methods: {
            toggleCollapsible() {
                this.showContent = !this.showContent;
            }
        },
        data() {
            return {
                showContent: false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/BaseCollapsible.vue